/* src/app/admin-dashboard/overview/kantine-overview/kantine-overview.component.css */
/*# sourceMappingURL=kantine-overview.component.css.map */
